// extracted by mini-css-extract-plugin
module.exports = {"attachment-list":"attachment-list--1UloyAwJ"};